/**
 * The backend renders every component through one `present({ kind, ... })` tool,
 * so a present call resolves its real presenter by `kind`. The concept presenters
 * stay registered under their own ids too, which keeps historical messages
 * (whose tool calls are named `presentCandidates`, `presentTableData`, …)
 * rendering unchanged.
 */
export const PRESENTER_ID_BY_KIND = <const>{
  candidates: 'presentCandidates',
  teamMembers: 'presentTeamMembers',
  jobs: 'presentJobs',
  talentPools: 'presentTalentPools',
  links: 'presentLinks',
  events: 'presentEvents',
  evaluations: 'presentEvaluations',
  tasks: 'presentTasks',
  requisitions: 'presentRequisitions',
  requestTicket: 'presentRequestTicket',
  requestForm: 'presentRequestForm',
  table: 'presentTableData',
  chart: 'presentChart',
  metricSummary: 'presentMetricSummary',
  sources: 'presentSources',
};

/** A `present` kind with a registered presenter. */
export type PresentKind = keyof typeof PRESENTER_ID_BY_KIND;

/** The registered presenter id for a `present` kind, or undefined for an unknown kind. */
export const presenterIdForKind = (kind: string | undefined): string | undefined =>
  kind && kind in PRESENTER_ID_BY_KIND ? PRESENTER_ID_BY_KIND[<PresentKind>kind] : undefined;
